exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".alert-basic{background-color:#f6f6f6;border:1px solid #ececec}\n", ""]);
